export const DELIVERY_FROM = 'rla.delivery_ready';
export const DELIVERY_FOR = 'rla.delivery_for';
export const PICKUP_FROM = 'rla.pickup_ready';
export const PICKUP_FOR = 'rla.pickup_for';
export const SHIPMENT_SERVICED_ON = 'rla.shipment_ready';
export const NEW_RECIPIENT = 'rla.new_recipient';
